<template>
  <v-card>
    <v-card-text>
      <template v-if="allowUseChatGpt">
        <div class="headline">Recommended sentence จาก ChatGPT</div>
        <v-layout align-center>
          <v-flex>
            <div class="primary--text title">{{ suggestChatGpt.length }} ผลลัพธ์</div>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn
              color="primary"
              outline
              :loading="loadingChatGpt"
              @click="handleSearchChatGptMore"
            >
              <v-icon>search</v-icon>
              Search more
            </v-btn>
          </v-flex>
        </v-layout>
        <div>เลือก/สร้าง บทสนทนาที่ต้องการเพิ่ม</div>
        <div style="border: 1px solid #eee; border-radius: 10px" class="pa-2 mb-2">
          <div v-if="suggestChatGpt.length == 0" class="text-xs-center my-4">No data</div>
          <template v-else>
            <ul class="tags">
              <li
                v-for="(word, index) in suggestChatGpt"
                :key="'word_' + word.id + '_' + index"
                class="tag"
                :class="{ active: selected.includes(word) }"
                style="margin-right: 5px; margin-bottom: 5px; cursor: pointer; text-align: left"
                :title="word"
                @click="handleToggleQuestiondata(word)"
              >
                <span
                  :class="{
                    'fas fa-check-circle': selected.includes(word),
                    'far fa-circle': !selected.includes(word)
                  }"
                ></span>
                <div style="display: inline-block; vertical-align: middle; word-break: break-all">
                  {{ word }}
                </div>
              </li>
            </ul>
          </template>
          <div v-if="loadingChatGpt" class="text-xs-center my-4">
            <v-progress-circular indeterminate color="primary" />
          </div>
        </div>
      </template>
      <QuestionDataExample
        :selected="selected"
        :questions="questions"
        @onToggleQuestiondata="handleToggleQuestiondata"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn outline color="grey" :loading="loading" @click="handleCancel"
        >{{ $t('cancel') }}
      </v-btn>
      <v-btn depressed color="primary" :loading="loading" @click="handleSave">
        {{ $t('Save') }}
      </v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import autoTrainingApi from '@/api/auto-training'
import { handleApiError } from '@/api/util'
import cloneDeep from 'lodash/cloneDeep'
import QuestionDataExample from './QuestionDataExample.vue'
export default {
  components: {
    QuestionDataExample
  },
  props: ['allowUseChatGpt', 'selectedQuestions'],
  data() {
    return {
      questions: [],
      selected: [],
      loadingChatGpt: false,
      loading: false,
      suggestChatGpt: []
    }
  },
  computed: {
    hightestScoreQuestion() {
      if (this.selectedQuestions.length > 0) {
        const hightestScoreQuestion = this.selectedQuestions.reduce((prev, current) =>
          prev.score > current.score ? prev : current
        )
        return hightestScoreQuestion.questiondata
      } else {
        return null
      }
    }
  },
  async mounted() {
    this.questions =
      this.selectedQuestions && this.selectedQuestions.length
        ? cloneDeep(this.selectedQuestions)
        : []
    if (this.questions && this.questions.length > 0) {
      this.selected = this.questions.map((item) => item.questiondata)
    }
    if (this.allowUseChatGpt) {
      await this.handleSearchChatGptMore()
    }
  },
  methods: {
    handleSearchChatGptMore() {
      this.handleGetSuggestFromChatGpt()
    },
    async handleGetSuggestFromChatGpt() {
      if (!this.hightestScoreQuestion) {
        this.$swal({
          title: 'ไม่พบข้อมูล',
          text: 'กรุณาเลือกคำถามที่ต้องการเพิ่ม',
          type: 'warning',
          confirmButtonText: 'ตกลง'
        })
        return false
      }
      try {
        this.loadingChatGpt = true
        const response = await autoTrainingApi.getGptSuggest({
          config: {
            params: {
              page_id: this.$store.state.selectedBot.pageid
            }
          },
          data: {
            language: 'th',
            keyword: this.hightestScoreQuestion
          }
        })
        if (response.status == 200 && response.data.result && response.data.result.choices) {
          this.suggestChatGpt = [...(this.suggestChatGpt || []), ...response.data.result.choices]
        }
        this.loadingChatGpt = false
      } catch (error) {
        this.loadingChatGpt = false
        handleApiError(error)
      }
    },
    handleToggleQuestiondata(word) {
      if (this.loading) return false
      if (word) {
        if (this.selected.includes(word)) {
          this.selected = this.selected.filter((item) => item !== word)
        } else {
          this.selected.push(word)
        }
      }
    },
    handleCancel() {
      this.$emit('onCancel')
    },
    async handleSave() {
      if (this.selected.length == 0) {
        await this.$swal({
          title: 'ไม่พบข้อมูล',
          text: 'กรุณาเลือกคำถามที่ต้องการเพิ่ม',
          type: 'warning'
        })
        return false
      }
      this.loading = true

      this.loading = false
      this.$emit('onSave', {
        words: this.selected
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Training/DialogSuggestWording.vue